/*  Shared  */
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

class WelcomeEmail {
    constructor() {
        this.requests = new Requests();
    }

    cancel = () => {
        this.requests.cancel();
    };

    // eslint-disable-next-line class-methods-use-this
    sendWelcomeEmail = async ({ emails, session, clientId = null, t }) => {
        const variables = {
            PARTNER_EMAIL: session.user.email,
            PARTNER_NAME: session.tenant.name
        };

        const emailFailed = [];

        for (let i = 0; i < emails.length; i += 1) {
            const email = emails[i];
            variables.EMAIL = email;

            try {
                const params = {
                    template: 'welcomeEmail',
                    to: email,
                    variables
                };
                if (clientId) {
                    params.platformTenantId = clientId;
                }

                // TODO: Fix - SAAS-994
                // eslint-disable-next-line no-await-in-loop
                await axios.post('/email', params);
            } catch (e) {
                debug.e(`Unable to send Welcome Email to ${email} `, e);
                emailFailed.push(email);
            }
        }

        if (emailFailed.length > 0) {
            const err = t('Users.invite.emailFail', {
                emails: emailFailed.join(', ')
            });
            throw new Error(err);
        }
    };
}

export default WelcomeEmail;
